import React from 'react';
import App from './AppLegacy';

// Wrapper to render the existing App component
const LegacyApp: React.FC = () => {
    return <App />;
};

export default LegacyApp;
